import { STORE_KEYS } from 'configs/fetchApi';
import { callFetch, callStoreFetch } from './response';
import { accessTokenHeader } from './settings';

const EndPoint = {
    GetCreateCustomer: (lineId) => `/v1/users/${lineId}`,
    UpdateCustomer: (lineId) => `/v1/users/${lineId}`,
    DrawCoffee: (lineId) => `/v1/prize/draw/coffee/${lineId}`,
    DrawPrize: (lineId) => `/v1/prize/draw/prize/${lineId}`,
    ShareThreeFriends: (lineId) => `/v1/users/share/${lineId}`
};

/**
 * @typedef {Object} ProfileType
 * @property {string} userId
 * @property {string} displayName
 * @property {string} pictureUrl
 */

/**
 * data
 * @param {string} recommendLineId
 * @param {string} lineId
 * @param {ProfileType} profile
 * @returns response
 */

export function getStoreCreateCustomer(data, accessToken) {
    const cli = callStoreFetch(STORE_KEYS.SERVER_CUSTOMER, getStoreCreateCustomer.name);
    const uri = EndPoint.GetCreateCustomer(data.lineId);
    let settings = {
        method: 'POST',
        headers: { ...accessTokenHeader(accessToken) },
        body: JSON.stringify({ ...data })
    };

    return cli(uri, settings);
}

// only for AuthProvider getCreateCustomer
export function getCreateCustomer(data, accessToken) {
    const uri = EndPoint.GetCreateCustomer(data.lineId);
    const settings = {
        method: 'POST',
        headers: { ...accessTokenHeader(accessToken) },
        body: JSON.stringify({ ...data })
    };

    return callFetch(uri, settings);
}

export function updateStoreCustomer(lineId, data, accessToken) {
    const cli = callStoreFetch(STORE_KEYS.SERVER_CUSTOMER, updateStoreCustomer.name);
    const uri = EndPoint.UpdateCustomer(lineId);
    let settings = {
        method: 'PATCH',
        headers: { ...accessTokenHeader(accessToken) },
        body: JSON.stringify({ ...data })
    };

    return cli(uri, settings);
}

export function drawCoffee(lineId, accessToken) {
    const uri = EndPoint.DrawCoffee(lineId);
    let settings = {
        method: 'POST',
        headers: { ...accessTokenHeader(accessToken) }
    };

    return callFetch(uri, settings);
}
export function drawPrize(lineId, accessToken) {
    const uri = EndPoint.DrawPrize(lineId);
    let settings = {
        method: 'POST',
        headers: { ...accessTokenHeader(accessToken) }
    };

    return callFetch(uri, settings);
}
export function shareThreeFriends(lineId, accessToken) {
    const cli = callStoreFetch(STORE_KEYS.SERVER_CUSTOMER, shareThreeFriends.name);
    const uri = EndPoint.ShareThreeFriends(lineId);
    let settings = {
        method: 'POST',
        headers: { ...accessTokenHeader(accessToken) }
    };

    return cli(uri, settings);
}
